module.exports = __webpack_public_path__ + "static/media/truck-moving.27b29be3.svg";